import Component from 'core/Component';
import { deepMerge } from 'toolbox/deepMerge';
import { on } from 'toolbox/event';
import { cookie } from 'toolbox/cookie';

/**
 * WhatsApp component handles datalayer push of analytics info
 * @class
 * @classdesc If analytics info is present, component will push when user will click on the link
 * @extends Component
 */
export default class WhatsApp extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            analytics: {},
            dataLayerContainer: 'dataLayer',
        }, options));
    }

    /**
     * All selectors must be cached. Never cache elements that are out of the component scope
     */
    initCache() {
        super.initCache();
        this.selectors.closeButton = this.options.showCloseBtn ? this.element.querySelectorAll('.whatsapp-chat-close') : null;
    }

    /**
     * After init
     * Run any script after the component is fully initialized
     */
    afterInit() {
        if (this.options.showCloseBtn && cookie.getCookie('whatsapp-popup-closed')) {
            this.setClosePopupCookie();
        } else {
            this.element.classList.remove('h-hidden');
        }
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        on('click', this.element, this.onClick.bind(this));
        if (this.selectors.closeButton) {
            on('click', this.selectors.closeButton, this.closePopup.bind(this));
        }
    }

    /**
     * Send analytics event on the click of link
     */
    onClick() {
        if (this.options.analytics) {
            const dataLayerContainer = window[this.options.dataLayerContainer];
            if (dataLayerContainer) {
                dataLayerContainer.push(this.options.analytics);
            }
        }
    }

    /**
     * Closes popup
     * @param {Object} e - Event object
     */
    closePopup(e) {
        e.preventDefault();
        e.stopPropagation();

        this.element.classList.add('h-hidden');
        this.setClosePopupCookie();
    }

    /**
     * sets a 30min cookie for hiding popup after its closing
     */
    setClosePopupCookie() {
        const expDate = new Date();
        expDate.setMinutes(expDate.getMinutes() + 30);
        document.cookie = `whatsapp-popup-closed=true;expires=${expDate.toUTCString()};path=/`;
    }
}
